import BaseValidator from 'services/validations/base-validator';
import {groupObjectsByProp} from 'helpers/array-helper';
import {isObject} from 'helpers/object-helper';

class MinPlayersOnPositionValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        const playersGroupedByPosition = this.getPlayersGroupedByPosition();
        const positions = sportConfig.getConfigProp('positions', {});
        const flexPositions = this.getFlexPositions();

        const errorMessages = [];
        for (let key in positions) {
            if (inArray(Number(key), flexPositions)) {
                continue;
            }

            const playersOnPosition = playersGroupedByPosition[key] || [];
            const {minPlayers, shortName} = positions[key];

            if (minPlayers > playersOnPosition.length) {
                // @ts-ignore
                errorMessages.push(`You must select at least ${minPlayers} ${shortName}\'s.`);
            }
        }

        if (!isEmpty(errorMessages)) {
            this.addError(errorMessages.join(', '));
        }
    }

    private getPlayersGroupedByPosition(): object {
        // @ts-ignore
        const {sportConfig, playersDividedByPosition} = this.dependencies;
        const positions = sportConfig.getConfigProp('positions', {});
        const playersGroupedByPlayerPosition = groupObjectsByProp(playersDividedByPosition, 'position');

        const playersGroupedByKeyPosition = {};
        Object.keys(positions).map((key) => {
            playersGroupedByKeyPosition[key] = [];

            positions[key].allowedPositions.map((allowedPosition) => {
                playersGroupedByKeyPosition[key] = [
                    ...playersGroupedByKeyPosition[key],
                    ...(playersGroupedByPlayerPosition[allowedPosition] || []),
                ];
            });
        });

        return playersGroupedByKeyPosition;
    }

    private getFlexPositions(): any[] {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        const flexPositions = sportConfig.getConfigProp('flexPlayerPosition', {});

        return isObject(flexPositions) ? Object.values(flexPositions) : [];
    }
}

export {MinPlayersOnPositionValidator};
